import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { portalApi, clearPortalToken, isPreview } from './portalApi';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export const PortalChangePassword = () => {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isPreview()) navigate('/portal');
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error('As senhas não conferem.');
      return;
    }
    setLoading(true);
    try {
      await portalApi.post('/api/portal/auth/change-password', { current_password: current, new_password: next });
      toast.success('Senha alterada com sucesso!');
      navigate('/portal');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Não foi possível alterar a senha.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <Card className="w-full max-w-md" data-testid="portal-change-password-card">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl">Criar nova senha</CardTitle>
          <CardDescription>No primeiro acesso, defina uma senha pessoal.</CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="cur">Senha atual</Label>
              <Input id="cur" type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
                required data-testid="portal-current-password" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="new">Nova senha</Label>
              <Input id="new" type="password" value={next} onChange={(e) => setNext(e.target.value)}
                required data-testid="portal-new-password" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="conf">Confirmar nova senha</Label>
              <Input id="conf" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                required data-testid="portal-confirm-password" />
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-3">
            <Button type="submit" className="w-full" disabled={loading} data-testid="portal-change-password-button">
              {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}
              Salvar nova senha
            </Button>
            <Button type="button" variant="ghost" className="w-full" onClick={() => { clearPortalToken(); navigate('/portal/login'); }}>
              Sair
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
};
